module.exports = __webpack_public_path__ + "img/5.1.afb2cb36.svg";